import { render, staticRenderFns } from "./ThankYouPage.vue?vue&type=template&id=36ab6fd6&scoped=true"
import script from "./ThankYouPage.vue?vue&type=script&lang=js"
export * from "./ThankYouPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ab6fd6",
  null
  
)

export default component.exports